/**
* @brandOverride URBNWeb
*/
import {
    attachEvents as rrOriginalAttachEvents
} from '../../../core/js/components/richRelevanceComponent';

import { isDeviceTypeLargerThan, DEVICE_CHARACTERISTICS_SIZE } from '../../../core/js/utils/generalUtils';

import { setProductTileSwatchImage, setProductTileSwatchUrl } from '../utils/tileUtils';

import { getRRPlacement, getDYPlacementIdFromSettings, isRightRailEnabled } from '../../../core/js/utils/rrUtils';

function rrAttachEvents(store) {
    rrOriginalAttachEvents.bind(this)(store);

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-swatch-link-category'), (e) => {
        e.preventDefault();

        setProductTileSwatchImage(store, e);
        setProductTileSwatchUrl(e);
    });
}

export function generateDictionary(state, dictionary, config) {
    const dict = _.pick(state, ['core']);
    const rrPlacement = getRRPlacement(state, config.rrPlacement);
    const maxTileCount = _.get(dict, 'core.constants.thirdParty.default.rich_relevance.max_tile_count');

    if (maxTileCount && _.get(dict, `core.rrRecs.${rrPlacement}`)) {
        dict.core.rrRecs[rrPlacement].maxTileCount = maxTileCount;
    }
    return Object.assign({}, state, dict, dictionary);
}

function beforeAttachEvents() {
    const state = this.getState();
    const showCarouselAtDesktop = _.get(state, 'core.constants.thirdParty.default.rich_relevance.pdp_show_carousel_at_desktop');
    let isSwiper = true;

    // Show Carousel For Desktop on AN
    if (isDeviceTypeLargerThan(state, DEVICE_CHARACTERISTICS_SIZE.MEDIUM)) {
        isSwiper = showCarouselAtDesktop;
    }

    this.isSwiper = isSwiper;
}

export function beforeConstruction(store) {
    // set rrPlacement component property according to value of productPrimary RR placement id in the Tornado settings
    const state = store.getState();

    const productPrimaryPlacement = getDYPlacementIdFromSettings(state, 'productPrimary');

    if (productPrimaryPlacement) {
        this.rrPlacement = productPrimaryPlacement;
    }
}

export function getRROverrides(state) {
    return {
        templateLocation: '.dom-ymal-rr .dom-rr-container',
        attachEvents: rrAttachEvents,
        generateDictionary: generateDictionary,
        beforeAttachEvents: beforeAttachEvents,
        beforeConstruction: beforeConstruction,
        isComponentValid: () => !isRightRailEnabled(state),
        name: 'youMayAlsoLikeComponent'
    };
}
